export default __webpack_public_path__ + "static/media/stats-preview-card-thumbnail2.2a416d88.png";